import React, { useState } from "react";
import { getImageUrl } from "../../../utils/imageUtils";
import styles from "./ProductImage.module.css";

interface ProductImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackAlt?: string;
  srcSet?: string;
}

const ProductImage: React.FC<ProductImageProps> = ({
  src,
  alt,
  fallbackAlt = "Product Image",
  className,
  srcSet,
  ...props
}) => {
  const [error, setError] = useState(false);

  return (
    <img
      src={error ? getImageUrl() : getImageUrl(src)}
      srcSet={srcSet}
      width="250"
      height="290"
      alt={alt || fallbackAlt}
      onError={() => setError(true)}
      className={`${styles.productImage} ${className || ""}`}
      {...props}
    />
  );
};

export default ProductImage;
